import React, { useRef } from "react";
import { useModal } from "../context/ModalContext";
import { Sheet } from "react-modal-sheet";
// mui icons
import { Close } from "@mui/icons-material";

//
import SignUp from "../screens/auth/SignUp";
import SignIn from "../screens/auth/SignIn";
import SignUpToReview from "../screens/auth/SignUpToReview";
import ForgottenPass from "../screens/auth/ForgottenPass";
import ForgottenUsername from "../screens/auth/ForgottenUsername";

const Modal = () => {
  const { currentModal, closeModal, setCurrentModal } = useModal();
  const containerHeight = useRef(null);


  if (!currentModal) return null;

  return (
    <Sheet detent="content-height" isOpen={true} onClose={closeModal} style={{ zIndex: 99999, background: "rgba(0,0,0,.7)" }} disableDrag={true}>
      <Sheet.Container ref={(node) => containerHeight.current = node?.getBoundingClientRect().height} style={{ background: "#f5f5f5", paddingBottom: "50px" }}>
        <Sheet.Header style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            onClick={() => closeModal(true)}
            style={{
              ...styles?.report?.closeButton,
              zIndex: 100,
              position: "absolute",
              background: "rgba(245,245,245,.5)",
              width: 40,
              height: 40,
              right: 10,
              top: 10,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              borderRadius: 20,
            }}
          >
            <Close />
          </div>
        </Sheet.Header>
        <Sheet.Content style={{ overflowY: "auto", maxWidth: "1140px", margin: "0 auto" }}>
          {/** MODALS */}
          {currentModal === "signUp" && <SignUp />}

          {currentModal === "signIn" && <SignIn />}
          {currentModal === "forgottenPass" && <ForgottenPass setCurrentModal={setCurrentModal} minHeight={containerHeight?.current} />}
          {currentModal === "forgottenUsername" && <ForgottenUsername />}
          {currentModal === "signUptoReview" && <SignUpToReview />}
        </Sheet.Content>
      </Sheet.Container>
    </Sheet >
  );
};

const styles = {
  closeButton: {
    cursor: "pointer",
    position: "absolute",
    top: 10,
    right: 10,
    fontSize: 20,
  },
};

export default Modal;
